import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capturePageView } from "./service";

/**
 * Tracks a PostHog $pageview whenever the React Router location changes.
 * Must be rendered inside <BrowserRouter>.
 */
const PostHogPageView = () => {
  const location = useLocation();

  useEffect(() => {
    capturePageView(location);
  }, [location.pathname, location.search, location.hash, location]);

  return null;
};

export default PostHogPageView;
